module.exports = __webpack_public_path__ + "static/media/rotaClock2.e4709b63.svg";